import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {Scrollbars} from "react-custom-scrollbars";

import Topbar from "./components/Topbar";
import Sidebar from "./components/Sidebar";
import {ProjectDescription} from "../../components/ProjectDescription";

import{setUser} from  "../../store/user/actions"

import {PrivateRoute} from "../../utils/PrivateRoute"
import Routes from "../../router/Routes";
import {HOME_PAGE_PATH} from '../../router/paths';
import jwtDecode from "jwt-decode";

const Layout =(props)=> {
 const  {setUser} = props;

  useEffect(()=>{
    const TOKEN = localStorage.getItem("token")
    if(TOKEN){
      const user = jwtDecode(JSON.parse(TOKEN).access_token);
      setUser(user);
    }
  },[setUser])

  return (
    <div id="main">
      <div id="main__content">
        <div id="topbar">
          <PrivateRoute
            path={HOME_PAGE_PATH}
            component={Topbar}
          />
        </div>
        <div id="content">
          <Scrollbars
            style={{width: '100%', minHeight: 'calc(100vh - 50px)'}} autoHide>
            <PrivateRoute component={Routes}/>
          </Scrollbars>
        </div>
      </div>
      <div id='sidebar'>
        <PrivateRoute
          path={HOME_PAGE_PATH}
          component={Sidebar}
        />
        <ProjectDescription/>
      </div>
    </div>
  );

}


function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setUser: (user) => dispatch(setUser(user)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
